"use strict";
var $dyn;
(function ($dyn) {
    var messaging;
    (function (messaging) {
        Globalize.addCultureInfo("en", {
            messages: {
                MessageBox_ErrorIcon: "Error icon",
                MessageBox_InfoIcon: "Information icon",
                MessageBox_WarningIcon: "Warning icon",
                MessageCenter_StatusActive: "Active",
                MessageCenter_StatusCompleted: "Completed",
                MessageCenter_StatusExpired: "Expired",
                MessageCenter_StatusHeader: "Status",
                Shell_PrefixMessagePane_MaxMessages: "This result has too many messages to show.",
                Shell_PrefixMessagePane_MaxMessagesPlease: "Please try again with fewer selections.",
                Shell_PrefixMessagePane_Title: "Message details",
                Shell_PrefixRootMessage_DetailLinkText: "Message details",
            }
        });
        /**
         * Enum for Message actions
         */
        var MessageAction;
        (function (MessageAction) {
            MessageAction[MessageAction["AddMessage"] = 0] = "AddMessage";
            MessageAction[MessageAction["RemoveMessage"] = 1] = "RemoveMessage";
            MessageAction[MessageAction["ClearMessages"] = 2] = "ClearMessages";
        })(MessageAction = messaging.MessageAction || (messaging.MessageAction = {}));
        /**
         * Enum for Message type
         */
        var MessageType;
        (function (MessageType) {
            MessageType[MessageType["information"] = 0] = "information";
            MessageType[MessageType["warning"] = 1] = "warning";
            MessageType[MessageType["error"] = 3] = "error";
            MessageType[MessageType["controlValidation"] = 19] = "controlValidation";
            MessageType[MessageType["fieldValidation"] = 20] = "fieldValidation";
            MessageType[MessageType["systemMaintenance"] = 21] = "systemMaintenance";
            MessageType[MessageType["itemNotOpened"] = 91] = "itemNotOpened";
            MessageType[MessageType["itemDoesNotExist"] = 92] = "itemDoesNotExist";
        })(MessageType = messaging.MessageType || (messaging.MessageType = {}));
        /**
         * Enum for Origin Type
         */
        var OriginType;
        (function (OriginType) {
            OriginType[OriginType["InfoLog"] = 0] = "InfoLog";
            OriginType[OriginType["Alert"] = 1] = "Alert";
            OriginType[OriginType["WatchDog"] = 2] = "WatchDog";
        })(OriginType = messaging.OriginType || (messaging.OriginType = {}));
        /**
         * Enum for Severity
         */
        var Severity;
        (function (Severity) {
            Severity[Severity["information"] = 0] = "information";
            Severity[Severity["warning"] = 1] = "warning";
            Severity[Severity["error"] = 2] = "error";
        })(Severity = messaging.Severity || (messaging.Severity = {}));
        /**
         * Enum for State
         */
        var State;
        (function (State) {
            State["active"] = "Active";
            State["completed"] = "Completed";
            State["expired"] = "Expired";
        })(State = messaging.State || (messaging.State = {}));
        /**
         * Enum for NotificationAction Type
         */
        var NotificationActionType;
        (function (NotificationActionType) {
            NotificationActionType[NotificationActionType["displayMenuFunction"] = 0] = "displayMenuFunction";
            NotificationActionType[NotificationActionType["actionMenuFunction"] = 1] = "actionMenuFunction";
        })(NotificationActionType = messaging.NotificationActionType || (messaging.NotificationActionType = {}));
        /**
         * Adds messages to the message manager.
         */
        function addMessage(message) {
            $dyn.messageManager.add(message);
        }
        messaging.addMessage = addMessage;
        /**
         * Return the message label for the correct message type for Aria usage
         * @internal
         * @param messageType the current message type.
         * @returns The message bar label
         */
        function getMessageBarAriaLabel(messageType) {
            if (messageType === $dyn.messaging.MessageType.information) {
                return ($dyn.label("MessageInfoBarNotificationAria"));
            }
            if (messageType === $dyn.messaging.MessageType.warning) {
                return ($dyn.label("MessageWarningBarNotificationAria"));
            }
            if (messageType === $dyn.messaging.MessageType.error) {
                return ($dyn.label("MessageErrorBarNotificationAria"));
            }
        }
        messaging.getMessageBarAriaLabel = getMessageBarAriaLabel;
        /**
         * Gets the most severe icon type of the messages.
         * @internal
         * @param messages The messages.
         * @return The most severe icon type of the messages.
         */
        function getMessageIconType(messages) {
            var iconTypes = [];
            // tslint:disable-next-line: prefer-for-of
            for (var i = 0; i < messages.length; i++) {
                if (messages[i].getMessageIconType) {
                    iconTypes.push(messages[i].getMessageIconType());
                }
            }
            if (iconTypes.length > 0) {
                if (iconTypes.indexOf("Error") >= 0) {
                    return "Error";
                }
                else if (iconTypes.indexOf("Warning") >= 0) {
                    return "Warning";
                }
                else if (iconTypes.indexOf("Info") >= 0) {
                    return "Info";
                }
            }
            return "Error";
        }
        messaging.getMessageIconType = getMessageIconType;
        /**
         * Gets the Alt Text or Title to use for icon icon type of the messages.
         * @internal
         * @param messages The messages.
         * @return The most severe icon text of the messages.
         */
        function getMessageIconAltText(messages) {
            var iconTypes = [];
            // tslint:disable-next-line: prefer-for-of
            for (var i = 0; i < messages.length; i++) {
                if (messages[i].getMessageIconType) {
                    iconTypes.push(messages[i].getMessageIconType());
                }
            }
            if (iconTypes.length > 0) {
                if (iconTypes.indexOf("Error") >= 0) {
                    return $dyn.label("MessageBox_ErrorIcon");
                }
                else if (iconTypes.indexOf("Warning") >= 0) {
                    return $dyn.label("MessageBox_WarningIcon");
                }
                else if (iconTypes.indexOf("Info") >= 0) {
                    return $dyn.label("MessageBox_InfoIcon");
                }
            }
            return $dyn.label("MessageBox_ErrorIcon");
        }
        messaging.getMessageIconAltText = getMessageIconAltText;
        function getFirstFocusButton(options) {
            if (options.showYesButton) {
                return $dyn.controls.MessageBox.ButtonName.Yes;
            }
            else if (options.showYesToAllButton) {
                return $dyn.controls.MessageBox.ButtonName.YesToAll;
            }
            else if (options.showOkButton) {
                return $dyn.controls.MessageBox.ButtonName.Ok;
            }
            else if (options.showNoButton) {
                return $dyn.controls.MessageBox.ButtonName.No;
            }
            else if (options.showNoToAllButton) {
                return $dyn.controls.MessageBox.ButtonName.NoToAll;
            }
            else if (options.showCloseButton) {
                return $dyn.controls.MessageBox.ButtonName.Close;
            }
            else if (options.showCancelButton) {
                return $dyn.controls.MessageBox.ButtonName.Cancel;
            }
        }
        messaging.getFirstFocusButton = getFirstFocusButton;
        /**
         * Find the target form for a particular message.
         * @private
         * @param targetFormId The form ID associated with the message.
         * @return The target form context for the message.
         *  If targetFormId is not provided, returns the top most form with a messageBar.
         *  If the target form is not found, returns undefined.
         */
        function FindTargetForm(targetFormId) {
            if (targetFormId) {
                // todo resolve form vs flyout
                var foundForm = void 0;
                // Check the logical cases before spinning through all stacks
                var activeForm_1 = $dyn.context($dyn.shell.activeFormElement);
                if (activeForm_1 && activeForm_1.Id === targetFormId) {
                    foundForm = activeForm_1;
                }
                if (!foundForm) {
                    // Check the flyout stack for the matching form
                    foundForm = $dyn.flyout.flyoutManager.getFlyoutContextByFormId(targetFormId);
                }
                if (!foundForm) {
                    // Check the active form for form parts
                    // Messages directed to form parts not on the active form will be delivered to the message center.
                    if (activeForm_1 && $dyn.shell.activeFormElement.querySelector('[data-dyn-formid="' + targetFormId + '"]')) {
                        foundForm = activeForm_1;
                    }
                }
                if (!foundForm) {
                    // If not found, search all open forms (primary and dialog)
                    // The next two cases recheck the current root form and its dialogs, but it is highly unlikely we should need to find a form here
                    foundForm = $dyn.shell.findFormById($dyn.shell.stack, targetFormId);
                }
                if (!foundForm) {
                    // We don't support messages being displayed on lightboxes, so need to specifically search only form dialogs
                    for (var i = $dyn.length($dyn.shell.stack) - 1; i >= 0; i--) {
                        var currentForm = $dyn.context($dyn.shell.stack()[i]);
                        if (currentForm && currentForm.dialogStack()) {
                            foundForm = $dyn.shell.findFormById(currentForm.dialogStack, targetFormId);
                        }
                    }
                }
                if (foundForm && foundForm.routeMessagesToParent && foundForm.Root) {
                    foundForm = foundForm.Root;
                }
                return foundForm;
            }
        }
        messaging.FindTargetForm = FindTargetForm;
        function isNotification(message) {
            return message && message.notificationId !== undefined ? true : false;
        }
        messaging.isNotification = isNotification;
        function isMessage(message) {
            return message && message.messageId !== undefined ? true : false;
        }
        messaging.isMessage = isMessage;
        function controlCanHaveMessages(control) {
            return control && "addMessage" in control ? true : false;
        }
        messaging.controlCanHaveMessages = controlCanHaveMessages;
    })(messaging = $dyn.messaging || ($dyn.messaging = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Messaging.js.map
